module.exports = __webpack_public_path__ + "img/avatar7_11zon.10252b9b.webp";